import React, { useEffect, useState, useCallback } from 'react';

import CloseIcon from "../../assets/images/close.png";
import Popup from 'reactjs-popup';
import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';
import Select, { components } from "react-select";

import { useDrop } from 'react-dnd';
import { connect } from "react-redux";
import { compose } from "redux";

import { getUsers } from "../../store/actions/adminActions";
import { BsRobot } from "react-icons/bs";
import { IoRocketOutline, IoLayersOutline, IoChevronUp, IoChevronDown, IoCloudUploadOutline, IoArrowBack, IoCheckmarkCircle, IoWarning, IoDocumentText, IoStatsChart, IoClipboardOutline, IoFolderOpenOutline, IoGridOutline, IoBarChartOutline, IoClose, IoSearch, IoSaveOutline, IoPencilOutline } from "react-icons/io5";
import { HiOutlineDocumentText } from "react-icons/hi";
import { closeControl, addFindingAI, deleteFinding, updateFinding, addFinding, addAttachment, editControl, deleteControl, getControlDetails, addControlComment, deleteAttachment, createActionFromFinding } from "../../store/actions/riskActions";
import { deleteSurveyFile, deleteEvidence, uploadSurveyFile, updateSurveyEvidence, getEvidence, getSurveyQuestionById, editSurveyQuestion, assignOwnerToSurveyClause, getSurveyFiles, addSurveyQuestionComment, getFindingsBySurvey } from "../../store/actions/surveyActions.js";
import { PeoplePicker } from "../Action/ActionOverlay";
import { callOpenAIAPIFindings } from "../../utils/openAI.js";
import moment from 'moment';
import debounce from "lodash/debounce";

function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: 'none', // Remove the border
        boxShadow: state.isFocused
            ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
            : 'none', // Default to light gray bottom shadow
        backgroundColor: '#EEF0ED',
        padding: 1,
        transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
        '&:hover': {
            boxShadow: state.isFocused
                ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
                : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
        },
    }),

    menu: (provided) => ({
        ...provided,
        border: 'none', // Remove the border around the menu
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3b3b3b'
            : state.isFocused
                ? '#EEF0ED'
                : 'white', // Different background colors for selected, focused, and default
        color: state.isSelected ? 'white' : '#000',
        '&:hover': {
            backgroundColor: '#EEF0ED', // Light background on hover
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),

};






const QuestionOverlay = (props) => {

    const { getSurveyFilesFN, deleteSurveyFileFN, deleteEvidenceFN, uploadSurveyFileFN, updateSurveyEvidenceFN, getEvidenceFN, editSurveyQuestionFN, assignOwnerToSurveyClauseFN, question, question_id, getSurveyQuestionByIdFN, closeControlFN, deleteFindingFN, updateFindingFN, addFindingFN, addFindingAIFN, findings, fetchAISuggestions, loadingAI, risk_id, addAttachmentFN, editControlFN, users, profile, getUsersFN, closeQuestion, getControlDetailsFN, control_id, control_details, question_comments, control_comments, addSurveyQuestionCommentFN, addControlCommentFN, deleteAttachmentFN, onFindingsNeeded, onViewAction, onViewFinding, surveyFindings, getFindingsBySurveyFN, createActionFromFindingFN } = props;


    const fileInputRef = React.useRef(null);

    const handleFileChange = async (event) => {
        //console.log("upload, ", question_id, "Survey Id ", question?.survey_id);
        //console.log("upload, ", formState.Attachments);
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        setFormState((prevState) => ({
            ...prevState,
            Attachments: [
                ...(Array.isArray(prevState?.Attachments) ? prevState.Attachments : []),
                ...files,
            ],
        }));



        await Promise.all(
            files.map((file) =>
                uploadSurveyFileFN(file, question_id, question?.survey_id)
            )
        );
        // optional: lets you re-upload the same file without changing selection
        await getSurveyQuestionByIdFN(question_id);
        event.target.value = "";
    };


    const handleDeleteAttachment = (evidenceId) => {
        deleteEvidenceFN(evidenceId)
            .then(() => fetchEvidence())
            .catch((error) => console.error("Error deleting evidence:", error));
    };






    const closeFrom = async (formState) => {
        console.log("formState ", formState)
        await editSurveyQuestionFN(question_id, formState).catch(() => {});

        const answerVal = String(formState.answer || '').trim().toLowerCase();
        const shouldTriggerFindings =
            answerVal === 'hayir' || answerVal === 'no' ||
            formState.question_review_status === 'Rejected';

        if (shouldTriggerFindings && onFindingsNeeded) {
            onFindingsNeeded(question_id).catch(() => {});
        }

        closeQuestion();
    }

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";

        // Convert string to Date object (ensure it's treated as UTC)
        const date = new Date(dateString);

        // Get the date components in UTC to prevent timezone shifts
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getUTCDate()).padStart(2, "0");

        return `${year}-${month}-${day}`; // Return properly formatted YYYY-MM-DD
    };


    const [isLoading, setIsLoading] = useState(true);

    const [newItemLocal, setNewItemLocal] = useState("");

    const [commentState, setCommentState] = useState('');

    const [currentPage, setCurrentPage] = useState(1);

    const [findingBusy, setFindingBusy] = useState(false);

    const [formState, setFormState] = useState({
        question_text: '',
        Definition: '',
        ControlType: '',
        ControlPeriod: '',
        ControlPeriodCustom: '',
        Attachments: [],
        User: '',
        ControlEfficiency: '',
        StartDate: moment().format('YYYY-MM-DD'),
        EndDate: moment().format('YYYY-MM-DD'),
        Finding: '',
        Recommendation: '',
        Secondline: '',
        secondFindings: '',
        secondRecommendations: '',
        is_secondline: false,
        Checklist: [],
        compliance_types: [],
        question_review_status: '',
        rejection_reason: '',
    });


    const [isFindingOpen, setIsFindingOpen] = useState(false);





    const handleDrop = (droppedChecklist) => {
        setFormState(prev => {
            const newChecklist = [
                ...(prev.Checklist || []),
                { text: droppedChecklist.text.trim(), completed: false },
            ];
            return { ...prev, Checklist: newChecklist };
        });
        // or: handleRiskChange({ Checklist: newChecklist });  // but compute with prev
    };







    useEffect(() => {
        if (question_id) {
            getSurveyQuestionByIdFN(question_id);
            fetchEvidence();
        }
    }, [question_id]);

    useEffect(() => {
        if (question?.survey_id) {
            getFindingsBySurveyFN(question.survey_id);
        }
    }, [question?.survey_id]);

    const questionText = (question?.question_text || question?.text || '').slice(0, 50).toLowerCase();
    const questionFindings = questionText
        ? (Array.isArray(surveyFindings) ? surveyFindings : []).filter(
            (f) => (f.title || '').toLowerCase().includes(questionText)
          )
        : [];




    useEffect(() => {
        console.log("Here ", question)
        if (question) {
            let owners = [];
            if (Array.isArray(question.owners) && question.owners.length > 0) {
                owners = question.owners.map(o => ({
                    value: o.user_id ?? o.value,
                    label: o.label || `${o.first_name || ''} ${o.last_name || ''}`.trim(),
                    avatar: o.avatar || '',
                }));
            } else if (question.owner_user_id) {
                const found = listUsers.find(u => u.value === question.owner_user_id);
                if (found) owners = [found];
            }
            setFormState({
                question_text: question.question_text || '',
                answer: question.answer || '',
                User: owners,
                Attachments: question.files || [],
                question_review_status: question.question_review_status || '',
                rejection_reason: question.rejection_reason || question.fail_reason || '',
            });
        }
    }, [question, users]);






    const listUsers = users && users?.length > 0 ? users.map(user => ({ value: user.user_id, label: user.first_name + ' ' + user.last_name, avatar: user.avatar || '' })) : [];


    const handleRiskChange = (data) => {
        ////console.log("Handle Control change data", data);
        setFormState((prevState) => ({
            ...prevState,
            ...data, // Spread only the updated fields
            Attachments: data.Attachments || prevState.Attachments, // Preserve Attachments explicitly

        }));



        //updateServerData(data, "control", control_id);
    };


    ////////console.log("Random Control Details Log:",control_details);
    ////////console.log("formstate:", formState);


    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [evidenceList, setEvidenceList] = useState([]);

    const fetchEvidence = async () => {
        if (!question_id) return;
        try {
            const data = await getEvidenceFN({ question_id });
            setEvidenceList(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error(err);
        }
    };

    const [isEvidencePopupOpen, setIsEvidencePopupOpen] = useState(false);
    const [isSubmittingEvidence, setIsSubmittingEvidence] = useState(false);
    const [evidenceUploadTab, setEvidenceUploadTab] = useState('manuel');
    const emptyEvidenceForm = {
        evidence_title: '',
        vendor: '',
        type: '',
        category: '',
        expiry_date: '',
        status: 'Active',
        tags: '',
        files: [],
    };
    const [evidenceForm, setEvidenceForm] = useState(emptyEvidenceForm);

    const handleEvidenceDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleEvidenceDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleEvidenceDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const dropped = Array.from(e.dataTransfer.files || []);
        if (dropped.length) setEvidenceForm(prev => ({ ...prev, files: [...prev.files, ...dropped] }));
    };

    const handleEvidenceFileChange = (e) => {
        const selected = Array.from(e.target.files || []);
        if (selected.length) setEvidenceForm(prev => ({ ...prev, files: [...prev.files, ...selected] }));
        e.target.value = '';
    };

    const removeEvidenceFile = (idx) => {
        setEvidenceForm(prev => ({ ...prev, files: prev.files.filter((_, i) => i !== idx) }));
    };

    const handleEvidenceSubmit = async () => {
        if (!evidenceForm.files.length) return;
        setIsSubmittingEvidence(true);
        try {
            const tags = evidenceForm.tags
                ? evidenceForm.tags.split(',').map(t => t.trim()).filter(Boolean)
                : [];
            const metadata = {
                evidence_title: evidenceForm.evidence_title,
                vendor: evidenceForm.vendor,
                type: evidenceForm.type,
                category: evidenceForm.category,
                expiry_date: evidenceForm.expiry_date,
                status: evidenceForm.status,
                tags,
            };
            await Promise.all(
                evidenceForm.files.map(file => uploadSurveyFileFN(file, question_id, question?.survey_id, metadata))
            );
            await getSurveyQuestionByIdFN(question_id);
            await fetchEvidence();
            setEvidenceForm(emptyEvidenceForm);
            setIsEvidencePopupOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmittingEvidence(false);
        }
    };

    const [isEditEvidenceOpen, setIsEditEvidenceOpen] = useState(false);
    const [editingEvidence, setEditingEvidence] = useState(null);
    const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);

    const openEditEvidence = (att) => {
        const tagsRaw = att.tags
            ? (Array.isArray(att.tags) ? att.tags.join(', ') : att.tags)
            : '';
        setEditingEvidence({
            evidence_id: att.evidence_id || att.id,
            evidence_title: att.evidence_title || '',
            vendor: att.vendor || '',
            type: att.type || '',
            category: att.category || '',
            expiry_date: att.expiry_date ? att.expiry_date.slice(0, 10) : '',
            status: att.status || 'Active',
            tags: tagsRaw,
        });
        setIsEditEvidenceOpen(true);
    };

    const handleEditEvidenceSubmit = async () => {
        if (!editingEvidence?.evidence_id) return;
        setIsSubmittingEdit(true);
        try {
            const tags = editingEvidence.tags
                ? editingEvidence.tags.split(',').map(t => t.trim()).filter(Boolean)
                : [];
            await updateSurveyEvidenceFN(editingEvidence.evidence_id, {
                evidence_title: editingEvidence.evidence_title,
                vendor: editingEvidence.vendor,
                type: editingEvidence.type,
                category: editingEvidence.category,
                expiry_date: editingEvidence.expiry_date,
                status: editingEvidence.status,
                tags: JSON.stringify(tags),
            });
            await getSurveyQuestionByIdFN(question_id);
            await fetchEvidence();
            setIsEditEvidenceOpen(false);
            setEditingEvidence(null);
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmittingEdit(false);
        }
    };

    const isOwner = question && profile.user_id && Number(profile.user_id) === Number(question.owner_user_id);
    const canEdit = profile.role === "Admin" || profile.role === "Auditor" || isOwner;

    const disableEvent = React.useCallback(
        (e) => {
            if (isFindingOpen) return;
            if (!canEdit) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        [isFindingOpen, canEdit]
    );


    return (
        <Disable onClick={disableEvent} onKeyDown={disableEvent}>
            <div style={canEdit ? { pointerEvents: 'auto', userSelect: 'auto' } : { pointerEvents: 'none', userSelect: 'none' }} className='p-8'>

                {formState.is_secondline === true && (<div className="flex justify-left mb-1">
                    <button
                        onClick={() => setCurrentPage(1)}
                        className={`px-4 py-2 mx-2 transition duration-100 
                                ${currentPage === 1
                                ? 'w-fit border-b-2 border-[#3b3b3b] border-solid text-[#3b3b3b] font-semibold'
                                : 'w-fit border-b-2 border-transparent border-solid text-gray-500'}`}
                    >
                        Control
                    </button>

                    <button
                        className={`w-fit px-4 py-2 mx-2 border-b-2 transition duration-100 ${currentPage === 2
                            ? 'border-[#3b3b3b] text-[#3b3b3b] font-semibold'
                            : 'border-transparent text-gray-500'
                            }`}
                        onClick={() => setCurrentPage(2)}
                    >
                        Second Line
                    </button>
                </div>
                )}



                <div className="flex justify-between items-center mb-1">
                    <img src={CloseIcon} alt="Close" className="w-6 h-6 cursor-pointer absolute top-2 right-2" onClick={() => closeFrom(formState)} />
                </div>
                {currentPage === 1 && (
                    <div className={`pt-2 px-6 pb-6 bg-white rounded-lg`}>

                        {/* Auditor Decision tag */}
                        {(() => {
                            const status = formState.question_review_status || 'Pending';
                            const tagStyles = {
                                Accepted: 'bg-green-100 text-green-700 border-green-200',
                                Rejected: 'bg-red-100 text-red-700 border-red-200',
                                Pending:  'bg-yellow-100 text-yellow-700 border-yellow-200',
                            };
                            const displayLabel = { Accepted: 'Passed', Rejected: 'Failed', Pending: 'Pending' };
                            const cls = tagStyles[status] || tagStyles.Pending;
                            return (
                                <div className="mb-3">
                                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${cls}`}>
                                       {displayLabel[status] || status}
                                    </span>
                                </div>
                            );
                        })()}

                        <div className="flex justify-between items-center mb-1">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Question</label>
                        </div>

                        <div className="mb-4">
                            <input
                                type="text"
                                placeholder="Question"
                                value={formState.question_text}
                                onChange={(e) => handleRiskChange({ ...formState, question_text: e.target.value })}
                                className="w-full p-3 text-sm rounded mb-4 bg-[#EEF0ED] text-black"
                                style={{
                                    border: 'none', // Remove actual borders
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur

                            />



                        </div>

                        <div className="grid grid-cols-4 gap-4 mb-6">

                            {/* Assigned To */}
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-1 text-sm">Assigned To</label>
                                <PeoplePicker
                                    users={listUsers}
                                    value={Array.isArray(formState.User) ? formState.User : []}
                                    onChange={(arr) => setFormState(prev => ({ ...prev, User: arr }))}
                                    placeholder="Owners"
                                />
                            </div>

                            {/* Answer */}
                            <div className="flex flex-col col-span-3">
                                <label className="text-[#3b3b3b] mb-1 text-sm">Answer</label>

                                {question?.question_type === "yes_no" ? (
                                    <div className="relative">
                                        <select
                                            value={formState.answer || ""}
                                            onChange={(e) =>
                                                handleRiskChange({ ...formState, answer: e.target.value })
                                            }
                                            className="w-full text-sm rounded bg-[#EEF0ED] text-black appearance-none"
                                            style={{
                                                border: "none",
                                                backgroundColor: "#EEF0ED",
                                                padding: "8px",
                                                outline: "none",
                                                transition: "box-shadow 0.1s",
                                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                                            }}
                                            onFocus={(e) =>
                                                (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                                            }
                                            onBlur={(e) =>
                                                (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")
                                            }
                                        >
                                            <option value="">Select</option>
                                            <option value="Evet">Yes</option>
                                            <option value="Hayir">No</option>
                                        </select>

                                        <IoChevronDown
                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
                                            size={18}
                                        />
                                    </div>
                                ) : (
                                    <input
                                        type="text"
                                        placeholder="Answer"
                                        value={formState.answer || ""}
                                        onChange={(e) =>
                                            handleRiskChange({ ...formState, answer: e.target.value })
                                        }
                                        className="w-full text-sm rounded bg-[#EEF0ED] text-black"
                                        style={{
                                            border: "none",
                                            backgroundColor: "#EEF0ED",
                                            padding: "8px",
                                            outline: "none",
                                            transition: "box-shadow 0.1s",
                                            boxShadow: "inset 0 0 0 0 #3b3b3b",
                                        }}
                                        onFocus={(e) =>
                                            (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                                        }
                                        onBlur={(e) =>
                                            (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")
                                        }
                                    />
                                )}
                            </div>

                        </div>


                        {(profile.role === "Auditor" || formState.question_review_status === 'Rejected') && (
                            <div style={{ pointerEvents: 'auto' }} className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <h4 className="text-sm font-semibold text-gray-700 mb-3">Auditor Decision</h4>

                                {profile.role === "Auditor" ? (
                                    <>
                                        <div className="flex gap-3 mb-3">
                                            <button
                                                type="button"
                                                onClick={() => setFormState(prev => ({ ...prev, question_review_status: prev.question_review_status === 'Accepted' ? 'Pending' : 'Accepted', rejection_reason: '' }))}
                                                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                    formState.question_review_status === 'Accepted'
                                                        ? 'bg-green-600 text-white shadow-sm'
                                                        : 'bg-white border border-gray-300 text-gray-600 hover:bg-green-50 hover:border-green-400'
                                                }`}
                                            >
                                                <IoCheckmarkCircle size={16} />
                                                Pass
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setFormState(prev => ({ ...prev, question_review_status: prev.question_review_status === 'Rejected' ? 'Pending' : 'Rejected', rejection_reason: prev.question_review_status === 'Rejected' ? '' : prev.rejection_reason }))}
                                                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                    formState.question_review_status === 'Rejected'
                                                        ? 'bg-red-600 text-white shadow-sm'
                                                        : 'bg-white border border-gray-300 text-gray-600 hover:bg-red-50 hover:border-red-400'
                                                }`}
                                            >
                                                <IoClose size={16} />
                                                Fail
                                            </button>
                                        </div>
                                        {formState.question_review_status === 'Rejected' && (
                                            <div>
                                                <label className="text-xs text-gray-500 mb-1 block">Fail Reason</label>
                                                <textarea
                                                    placeholder="Explain the reason for failure..."
                                                    value={formState.rejection_reason || ''}
                                                    onChange={(e) => setFormState(prev => ({ ...prev, rejection_reason: e.target.value }))}
                                                    rows={3}
                                                    className="w-full p-2 text-sm rounded bg-[#EEF0ED] text-black resize-none"
                                                    style={{ border: 'none', outline: 'none', boxShadow: 'inset 0 0 0 0 #3b3b3b', transition: 'box-shadow 0.1s' }}
                                                    onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                                    onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    /* Read-only view for non-auditors when rejected */
                                    <div className="flex items-start gap-3">
                                        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-red-100 text-red-700 flex-shrink-0">
                                            <IoClose size={14} />
                                            Failed
                                        </span>
                                        {formState.rejection_reason && (
                                            <div className="flex-1 min-w-0">
                                                <p className="text-xs text-gray-500 mb-1">Reason</p>
                                                <p className="text-sm text-gray-700 whitespace-pre-wrap">{formState.rejection_reason}</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {(formState.answer === "Evet" || formState.answer === "Yes") && (
                            <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center gap-2">
                                        <HiOutlineDocumentText className="text-gray-600" size={20} />
                                        <span className="font-medium text-gray-800">Evidence Files</span>
                                        {evidenceList.length > 0 && (
                                            <span className="bg-blue-100 text-blue-600 text-xs font-medium px-2 py-0.5 rounded-full">
                                                {evidenceList.length}
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={async () => {
                                            await editSurveyQuestionFN(question_id, formState);
                                            setEvidenceForm(emptyEvidenceForm);
                                            setIsEvidencePopupOpen(true);
                                        }}
                                        className="inline-flex items-center gap-1.5 bg-gray-900 text-white text-sm font-medium px-3 py-1.5 rounded-lg hover:bg-gray-700 transition-colors"
                                    >
                                        <IoCloudUploadOutline size={15} />
                                        Add Evidence
                                    </button>
                                </div>

                                {/* Evidence table */}
                                {evidenceList.length > 0 ? (
                                    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
                                        <table className="w-full text-sm">
                                            <colgroup>
                                                <col style={{ width: '18%' }} />
                                                <col style={{ width: '22%' }} />
                                                <col style={{ width: '14%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '14%' }} />
                                                <col style={{ width: '13%' }} />
                                                <col style={{ width: '7%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr className="border-b border-gray-200 bg-gray-50 text-xs text-gray-500">
                                                    <th className="text-left px-3 py-2 font-medium">Title</th>
                                                    <th className="text-left px-3 py-2 font-medium">File</th>
                                                    <th className="text-left px-3 py-2 font-medium">Vendor</th>
                                                    <th className="text-left px-3 py-2 font-medium">Type</th>
                                                    <th className="text-left px-3 py-2 font-medium">Category</th>
                                                    <th className="text-left px-3 py-2 font-medium">Status</th>
                                                    <th className="px-3 py-2" />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {evidenceList.map((att) => {
                                                    const statusColors = {
                                                        Active: 'bg-green-100 text-green-700',
                                                        Expired: 'bg-red-100 text-red-700',
                                                        'Pending Review': 'bg-yellow-100 text-yellow-700',
                                                        Rejected: 'bg-gray-100 text-gray-600',
                                                    };
                                                    const statusClass = statusColors[att?.status] || 'bg-gray-100 text-gray-600';
                                                    return (
                                                        <tr key={att.evidence_id} className="border-b last:border-0 border-gray-100 hover:bg-gray-50">
                                                            <td className="px-3 py-2">
                                                                <span className="text-gray-800 font-medium truncate block text-xs" title={att.evidence_title}>
                                                                    {att.evidence_title || '—'}
                                                                </span>
                                                            </td>
                                                            <td className="px-3 py-2">
                                                                {att.s3_path ? (
                                                                    <a
                                                                        href={att.s3_path}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="flex items-center gap-1.5 text-blue-600 hover:underline"
                                                                        title={att.file_name}
                                                                    >
                                                                        <HiOutlineDocumentText size={13} className="flex-shrink-0" />
                                                                        <span className="truncate text-xs">{att.file_name || '—'}</span>
                                                                    </a>
                                                                ) : (
                                                                    <span className="text-gray-400 text-xs">—</span>
                                                                )}
                                                            </td>
                                                            <td className="px-3 py-2 text-gray-600 text-xs truncate">{att.vendor || '—'}</td>
                                                            <td className="px-3 py-2 text-gray-600 text-xs truncate">{att.type || '—'}</td>
                                                            <td className="px-3 py-2 text-gray-600 text-xs truncate">{att.category || '—'}</td>
                                                            <td className="px-3 py-2">
                                                                {att.status ? (
                                                                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${statusClass}`}>
                                                                        {att.status}
                                                                    </span>
                                                                ) : '—'}
                                                            </td>
                                                            <td className="px-3 py-2 text-right">
                                                                <div className="flex items-center justify-end gap-2">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => openEditEvidence(att)}
                                                                        className="text-gray-400 hover:text-blue-600"
                                                                    >
                                                                        <IoPencilOutline size={15} />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDeleteAttachment(att.evidence_id)}
                                                                        className="text-red-400 hover:text-red-600"
                                                                    >
                                                                        <TfiTrash size={15} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="text-sm text-gray-400 text-center py-4">No evidence added yet</p>
                                )}

                                {/* Add Evidence popup */}
                                {isEvidencePopupOpen && (
                                    <div
                                        className="fixed inset-0 z-[99999] flex items-center justify-center"
                                        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                                        onClick={(e) => { if (e.target === e.currentTarget) setIsEvidencePopupOpen(false); }}
                                    >
                                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
                                            {/* Header */}
                                            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0">
                                                <div className="flex items-center gap-2">
                                                    <IoCloudUploadOutline size={20} className="text-gray-700" />
                                                    <h3 className="text-base font-semibold text-gray-900">Add Evidence</h3>
                                                </div>
                                                <button type="button" onClick={() => setIsEvidencePopupOpen(false)} className="text-gray-400 hover:text-gray-600">
                                                    <IoClose size={20} />
                                                </button>
                                            </div>

                                            <div className="px-6 py-5 space-y-5 overflow-y-auto flex-1">
                                                {/* Upload tabs */}
                                                <div>
                                                    <div className="flex items-center gap-4 border-b border-gray-200 mb-4">
                                                        <button
                                                            type="button"
                                                            onClick={() => setEvidenceUploadTab('manuel')}
                                                            className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${evidenceUploadTab === 'manuel' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'}`}
                                                        >
                                                            <IoCloudUploadOutline size={17} />
                                                            Manual Upload
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => setEvidenceUploadTab('raboya')}
                                                            className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${evidenceUploadTab === 'raboya' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'}`}
                                                        >
                                                            <BsRobot size={17} />
                                                            Ask Raboya
                                                        </button>
                                                    </div>

                                                    {evidenceUploadTab === 'manuel' && (
                                                        <>
                                                            <div
                                                                className={`border-2 border-dashed rounded-xl p-6 text-center transition-colors ${isDragging ? 'border-blue-400 bg-blue-50' : 'border-gray-300 bg-gray-50 hover:border-gray-400'}`}
                                                                onDragOver={handleEvidenceDragOver}
                                                                onDragLeave={handleEvidenceDragLeave}
                                                                onDrop={handleEvidenceDrop}
                                                            >
                                                                <div className="flex flex-col items-center">
                                                                    <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                                                                        <IoCloudUploadOutline size={28} className="text-gray-400" />
                                                                    </div>
                                                                    <p className="text-gray-700 mb-3 text-sm">Drag files here or</p>
                                                                    <label className="cursor-pointer">
                                                                        <span className="bg-blue-600 text-white px-5 py-2 rounded-lg font-medium text-sm hover:bg-blue-700 transition-colors inline-flex items-center gap-2">
                                                                            <IoCloudUploadOutline size={16} />
                                                                            Select File
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            className="hidden"
                                                                            onChange={handleEvidenceFileChange}
                                                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.zip"
                                                                        />
                                                                    </label>
                                                                    <p className="text-xs text-gray-500 mt-2">PDF, Word, Excel, Image, ZIP supported</p>
                                                                </div>
                                                            </div>

                                                            {/* Selected files list */}
                                                            {evidenceForm.files.length > 0 && (
                                                                <div className="mt-3 space-y-1.5">
                                                                    {evidenceForm.files.map((f, idx) => (
                                                                        <div key={idx} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-3 py-2">
                                                                            <div className="flex items-center gap-2 min-w-0">
                                                                                <HiOutlineDocumentText className="text-gray-500 flex-shrink-0" size={16} />
                                                                                <span className="text-sm text-gray-700 truncate">{f.name}</span>
                                                                            </div>
                                                                            <button type="button" onClick={() => removeEvidenceFile(idx)} className="text-gray-400 hover:text-red-500 ml-2 flex-shrink-0">
                                                                                <IoClose size={16} />
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </>
                                                    )}

                                                    {evidenceUploadTab === 'raboya' && (
                                                        <div className="bg-white rounded-lg p-5 border border-gray-200">
                                                            <div className="flex items-start gap-4">
                                                                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                                                                    <BsRobot size={24} className="text-blue-600" />
                                                                </div>
                                                                <div className="flex-1">
                                                                    <h4 className="text-base font-semibold text-gray-900 mb-1">Evidence Collection with Raboya</h4>
                                                                    <p className="text-gray-500 text-sm leading-relaxed mb-4">
                                                                        Raboya AI assistant will automatically find and collect relevant evidence for this control from your connected GRC tools.
                                                                    </p>
                                                                    <button
                                                                        type="button"
                                                                        className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
                                                                    >
                                                                        <BsRobot size={16} />
                                                                        Ask Raboya
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Metadata fields */}
                                                <div className="grid grid-cols-2 gap-3">
                                                    <div className="col-span-2">
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Evidence Title</label>
                                                        <input type="text" placeholder="Enter title" value={evidenceForm.evidence_title}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, evidence_title: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Vendor</label>
                                                        <input type="text" placeholder="Vendor name" value={evidenceForm.vendor}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, vendor: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Type</label>
                                                        <input type="text" placeholder="Evidence type" value={evidenceForm.type}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, type: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Category</label>
                                                        <input type="text" placeholder="Category" value={evidenceForm.category}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, category: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Expiry Date</label>
                                                        <input type="date" value={evidenceForm.expiry_date}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, expiry_date: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                                                        <select value={evidenceForm.status}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, status: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white">
                                                            <option value="Active">Active</option>
                                                            <option value="Expired">Expired</option>
                                                            <option value="Pending Review">Pending Review</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-span-2">
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Tags <span className="text-gray-400 font-normal">(comma separated)</span></label>
                                                        <input type="text" placeholder="e.g.: ISO27001, MASAK, Q1-2025" value={evidenceForm.tags}
                                                            onChange={e => setEvidenceForm(p => ({ ...p, tags: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Footer */}
                                            <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between flex-shrink-0">
                                                <span className="text-xs text-gray-400">
                                                    {evidenceForm.files.length > 0 ? `${evidenceForm.files.length} file(s) selected` : 'No files selected'}
                                                </span>
                                                <div className="flex gap-3">
                                                    <button type="button" onClick={() => setIsEvidencePopupOpen(false)}
                                                        className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                                                        Cancel
                                                    </button>
                                                    <button type="button" onClick={handleEvidenceSubmit}
                                                        disabled={!evidenceForm.files.length || isSubmittingEvidence}
                                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors inline-flex items-center gap-2 ${evidenceForm.files.length && !isSubmittingEvidence ? 'bg-gray-900 text-white hover:bg-gray-700' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}>
                                                        <IoSaveOutline size={15} />
                                                        {isSubmittingEvidence ? 'Uploading…' : 'Save'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Edit Evidence overlay */}
                                {isEditEvidenceOpen && editingEvidence && (
                                    <div
                                        className="fixed inset-0 z-[99999] flex items-center justify-center"
                                        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                                        onClick={(e) => { if (e.target === e.currentTarget) { setIsEditEvidenceOpen(false); setEditingEvidence(null); } }}
                                    >
                                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
                                            {/* Header */}
                                            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                                                <div className="flex items-center gap-2">
                                                    <IoPencilOutline size={20} className="text-gray-700" />
                                                    <h3 className="text-base font-semibold text-gray-900">Edit Evidence</h3>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => { setIsEditEvidenceOpen(false); setEditingEvidence(null); }}
                                                    className="text-gray-400 hover:text-gray-600"
                                                >
                                                    <IoClose size={20} />
                                                </button>
                                            </div>

                                            <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">
                                                <div className="grid grid-cols-2 gap-3">
                                                    <div className="col-span-2">
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Evidence Title</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter title"
                                                            value={editingEvidence.evidence_title}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, evidence_title: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Vendor</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Vendor name"
                                                            value={editingEvidence.vendor}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, vendor: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Type</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Evidence type"
                                                            value={editingEvidence.type}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, type: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Category</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Category"
                                                            value={editingEvidence.category}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, category: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Expiry Date</label>
                                                        <input
                                                            type="date"
                                                            value={editingEvidence.expiry_date}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, expiry_date: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                                                        <select
                                                            value={editingEvidence.status}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, status: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                                                        >
                                                            <option value="Active">Active</option>
                                                            <option value="Expired">Expired</option>
                                                            <option value="Pending Review">Pending Review</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-span-2">
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Tags <span className="text-gray-400 font-normal">(comma separated)</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="e.g.: ISO27001, MASAK, Q1-2025"
                                                            value={editingEvidence.tags}
                                                            onChange={e => setEditingEvidence(p => ({ ...p, tags: e.target.value }))}
                                                            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Footer */}
                                            <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                                                <button
                                                    type="button"
                                                    onClick={() => { setIsEditEvidenceOpen(false); setEditingEvidence(null); }}
                                                    className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleEditEvidenceSubmit}
                                                    disabled={isSubmittingEdit}
                                                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors inline-flex items-center gap-2 ${!isSubmittingEdit ? 'bg-gray-900 text-white hover:bg-gray-700' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}
                                                >
                                                    <IoSaveOutline size={15} />
                                                    {isSubmittingEdit ? 'Saving…' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Findings */}
                        {questionFindings.length > 0 && (
                            <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center gap-2 mb-3">
                                    <IoWarning className="text-amber-500" size={18} />
                                    <span className="font-medium text-gray-800 text-sm">Findings</span>
                                    <span className="bg-amber-100 text-amber-700 text-xs font-medium px-2 py-0.5 rounded-full">
                                        {questionFindings.length}
                                    </span>
                                </div>
                                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                                    <div className="grid grid-cols-[1fr_0.8fr_0.7fr_0.7fr_0.9fr] gap-3 px-4 py-2.5 bg-gray-50 text-xs font-semibold text-gray-700 border-b border-gray-200">
                                        <div>Title</div>
                                        <div>Priority</div>
                                        <div>Status</div>
                                        <div>Date</div>
                                        <div>Approval</div>
                                    </div>
                                    <div className="divide-y divide-gray-100">
                                        {questionFindings.map((f) => {
                                            const priority = f.priority || '—';
                                            const status = (f.status === 'Problem' ? 'In Progress' : f.status) || 'Open';
                                            const findingDate = f.finding_date ? f.finding_date.slice(0, 10) : '—';
                                            const priorityColors = { High: 'bg-red-100 text-red-700', Medium: 'bg-yellow-100 text-yellow-700', Low: 'bg-green-100 text-green-700' };
                                            const priorityClass = priorityColors[priority] || 'bg-gray-100 text-gray-600';
                                            const approvalStatus = f.approval_status || 'Pending';
                                            const approvalColors = {
                                                Approved: 'bg-green-100 text-green-700',
                                                Rejected: 'bg-red-100 text-red-700',
                                                Pending: 'bg-yellow-100 text-yellow-700',
                                            };
                                            const approvalClass = approvalColors[approvalStatus] || approvalColors.Pending;
                                            const approvalLabel = approvalStatus;
                                            return (
                                                <div key={f.id} onClick={() => onViewFinding && onViewFinding(f)} className="grid grid-cols-[1fr_0.8fr_0.7fr_0.7fr_0.9fr] gap-3 items-center px-4 py-2.5 hover:bg-gray-50 transition-colors cursor-pointer">
                                                    <div className="text-xs text-gray-800 truncate min-w-0" title={f.title}>{f.title || '—'}</div>
                                                    <div><span className={`text-xs font-medium px-2 py-0.5 rounded-full ${priorityClass}`}>{priority}</span></div>
                                                    <div className="text-xs text-gray-600">{status}</div>
                                                    <div className="text-xs text-gray-600">{findingDate}</div>
                                                    <div>
                                                        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${approvalClass}`}>
                                                            {approvalLabel}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Comments */}
                        <section className="py-4">
                            <h4 className="font-semibold mb-3 text-[#3b3b3b]">Comments</h4>

                            {!!question_comments?.length && (
                                <div className="mb-4 space-y-3">
                                    {question_comments.map((comment) => (
                                        <div
                                            key={comment.CommentID}
                                            className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2"
                                        >
                                            <div className="flex items-center justify-between gap-3">
                                                <div className="flex items-center gap-2">
                                                    <Avatar
                                                        name={[comment.FirstName, comment.LastName].filter(Boolean).join(" ") || "Unknown User"}
                                                        src={comment.Avatar}
                                                        size={28}
                                                    />

                                                  
                                                </div>

                                                <div className="text-xs text-gray-500">
                                                    {comment.CommentDate
                                                        ? new Date(comment.CommentDate).toLocaleString()
                                                        : ""}
                                                </div>
                                            </div>

                                            <div className="mt-1 text-sm text-gray-700 whitespace-pre-wrap">
                                                {comment.CommentText}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="mb-6">
                                <textarea
                                    placeholder="Comments"
                                    className="w-full p-3 text-sm rounded bg-[#EEF0ED] text-black"
                                    style={{
                                        border: "none",
                                        backgroundColor: "#EEF0ED",
                                        padding: "8px",
                                        outline: "none",
                                        transition: "box-shadow 0.1s",
                                        boxShadow: "inset 0 0 0 0 #3b3b3b",
                                    }}
                                    onFocus={(e) => (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")}
                                    onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                                    value={commentState}
                                    onChange={(e) => setCommentState(e.target.value)}
                                />

                                <div className="flex justify-end mt-4">
                                    <button
                                        onClick={async () => {
                                            if (commentState?.trim()) {
                                                await addSurveyQuestionCommentFN(commentState, question_id);
                                                setCommentState("");
                                                getSurveyQuestionByIdFN(question_id);
                                            }
                                        }}
                                        disabled={!commentState?.trim()}
                                        className={`
          inline-flex items-center justify-center
          px-5 py-2.5
          text-sm font-medium
          rounded-xl
          transition-all duration-200 ease-out
          shadow-sm
          ${commentState?.trim()
                                                ? "bg-gradient-to-r from-gray-900 to-gray-700 text-white hover:shadow-md hover:-translate-y-[1px] active:translate-y-0"
                                                : "bg-gray-200 text-gray-400 cursor-not-allowed"
                                            }
        `}
                                    >
                                        Add Comment
                                    </button>
                                </div>
                            </div>
                        </section>

                    </div>
                )}



            </div>



        </Disable >
    );

};


const mapStateToProps = (state) => {
    console.log("surveyFindings:  ",state.audits?.findings)
    return {
        question: state.audits.question,
        risk: state.risk.risk,
        profile: state.profile.profile,
        control_details: state.risk.control_details,
        control_comments: state.risk.control_comments,
        question_comments: state.audits.question_comments,
        users: state.admin.admin_users,
        findings: state.risk.control_details?.findings,
        surveyFindings: state.audits?.findings,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getRiskFN: (id) => dispatch(getRisk(id)),
        //addCommentFN: (comment, risk_id) => dispatch(addComment(comment, risk_id)),
        // addControlFN: (risk_id) => dispatch(addControl(risk_id)),
        // addActionFN: (risk_id) => dispatch(addAction(risk_id)),
        addAttachmentFN: (risk_id, control_id, file) => dispatch(addAttachment(risk_id, control_id, file)),
        //editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        //editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        deleteControlFN: (risk_id, action_id) => dispatch(deleteControl(risk_id, action_id)),
        getControlDetailsFN: (risk_id, control) => dispatch(getControlDetails(risk_id, control)),
        addControlCommentFN: (comment, control_id) => dispatch(addControlComment(comment, control_id)),
        addSurveyQuestionCommentFN: (comment, question_id) => dispatch(addSurveyQuestionComment(comment, question_id)),
        deleteAttachmentFN: (control_id, attachment_id) => dispatch(deleteAttachment(control_id, attachment_id)), // Add this line
        getUsersFN: () => dispatch(getUsers()),
        addFindingFN: (control_id, type) => dispatch(addFinding(control_id, type)),
        addFindingAIFN: (control_id, aiResponse) => dispatch(addFindingAI(control_id, aiResponse)),
        updateFindingFN: (data, id) => dispatch(updateFinding(data, id)),
        deleteFindingFN: (id) => dispatch(deleteFinding(id)),
        closeControlFN: () => dispatch(closeControl()),
        getSurveyQuestionByIdFN: (id) => dispatch(getSurveyQuestionById(id)),
        editSurveyQuestionFN: (id, data) => dispatch(editSurveyQuestion(id, data)),
        deleteEvidenceFN: (evidenceId) => dispatch(deleteEvidence(evidenceId)),
        uploadSurveyFileFN: (file, questionId, surveyId, metadata) => dispatch(uploadSurveyFile(file, questionId, surveyId, metadata)),
        updateSurveyEvidenceFN: (evidenceId, metadata) => dispatch(updateSurveyEvidence(evidenceId, metadata)),
        getEvidenceFN: (params) => dispatch(getEvidence(params)),
        deleteSurveyFileFN: (fileId) => dispatch(deleteSurveyFile(fileId)),
        getSurveyFilesFN: (surveyId, questionId) => dispatch(getSurveyFiles(surveyId, questionId)),
        assignOwnerToSurveyClauseFN: (payload) => dispatch(assignOwnerToSurveyClause(payload)),
        getFindingsBySurveyFN: (id) => dispatch(getFindingsBySurvey(id)),
        createActionFromFindingFN: (item) => dispatch(createActionFromFinding(item)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(QuestionOverlay);